import { every, has } from 'lodash-es'

import { REQUIRED_DISH_FIELDS, REQUIRED_MENU_TITLE_FIELDS } from '../constants'

const validateMenuTitles = menuTitles => {
  if (!Array.isArray(menuTitles)) {
    return {
      isValid: false,
      error: 'menuTitles must be an array',
    }
  }

  const hasValidMenuTitles = every(menuTitles, menuTitle => {
    const hasParentId = has(menuTitle, 'parentId')
    const hasOtherFields = every(REQUIRED_MENU_TITLE_FIELDS, field =>
      has(menuTitle, field),
    )

    return hasParentId && hasOtherFields
  })

  if (!hasValidMenuTitles) {
    return {
      isValid: false,
      error:
        'Invalid menuTitles format. Each menuTitle must have: id, menuId, parentId, title, description, diets, addons, miscInfo, allergens, nutritions, calories',
    }
  }

  return { isValid: true }
}

const validateDishes = dishes => {
  if (!Array.isArray(dishes)) {
    return {
      isValid: false,
      error: 'dishes must be an array',
    }
  }

  const hasValidDishes = every(dishes, dish =>
    every(REQUIRED_DISH_FIELDS, field => has(dish, field)),
  )

  if (!hasValidDishes) {
    return {
      isValid: false,
      error:
        'Invalid dishes format. Each dish must have: id, menuId, menuTitleId, name, description, ingredients, price, diets, addons, miscInfo, allergens, nutritions, calories',
    }
  }

  return { isValid: true }
}

const validateUploadedMenuData = jsonData => {
  if (!jsonData.menuTitles || !jsonData.dishes) {
    return {
      isValid: false,
      error: 'Invalid JSON format. Expected {menuTitles: [], dishes: []}',
    }
  }

  const menuTitlesValidation = validateMenuTitles(jsonData.menuTitles)
  if (!menuTitlesValidation.isValid) {
    return menuTitlesValidation
  }

  const dishesValidation = validateDishes(jsonData.dishes)
  if (!dishesValidation.isValid) {
    return dishesValidation
  }

  return { isValid: true }
}

export default validateUploadedMenuData
